import React, { useState } from "react";
import axios from "../../../services/axios";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setVisible } from "../../../store/slices/translation";

import { StyledText } from "../game";
import CustomModal from "../../modal";

export default function TranslationErrorModal() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { visible, challenge, challenge_id, player1, player2 } = useSelector(
    (state) => state.translationError
  );
  const [step, setStep] = useState(0);
  const [suggestionText, setSuggestionText] = useState("");

  const handleClose = () => {
    dispatch(setVisible(false));
  };

  const handleAfterClose = () => {
    setStep(0);
    setSuggestionText("");
  };

  const handleYes = () => {
    setStep(1);
  };

  const handleSend = () => {
    try {
      if (suggestionText && challenge_id !== 0) {
        let json = {
          id_desafio: challenge_id,
          lingua: i18n.language.replace("-", "_"),
          sugestao_desafio: suggestionText,
          desafio_atual: `${challenge}`,
        };
        axios.post("sugestion/send", json);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setStep(2);
    }
  };

  return (
    <CustomModal
      visible={visible}
      handleClose={handleClose}
      handleAfterClose={handleAfterClose}
    >
      <div className="p-3 rounded-[20px] bg-[#36383F] border-[1px] border-[#6A6C71]">
        <h1 className="text-2xl font-bold uppercase">{t("errTitulo")}</h1>
        <hr className="border-[#6A6C71]"></hr>
        {step !== 2 ? (
          <StyledText
            phrase={challenge}
            userName={player2}
            playerOneName={player1}
            className="text-lg !font-medium mt-3 !mb-3 leading-5"
          />
        ) : (
          <div className="mt-4 mb-4">
            <p className="text-lg leading-5 font-medium">
              {t("thanksForFeedback")}
            </p>
          </div>
        )}
        <div>
          {step === 0 && (
            <div className="flex">
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-small me-2 btn-brand w-full"
              >
                {t("no")}
              </button>
              <button
                type="button"
                onClick={handleYes}
                className="btn btn-small ms-2 btn-success  w-full"
              >
                {t("yes")}
              </button>
            </div>
          )}
          {step === 1 && (
            <div>
              <p className="text-sm">{t("errCorrect")}</p>
              <input
                value={suggestionText}
                onChange={(e) => setSuggestionText(e.target.value)}
                className="w-full rounded pe-1 ps-1 text-black"
                type="text"
              />
              <div className="mt-4">
                <button
                  type="button"
                  onClick={handleSend}
                  className="btn btn-small me-2 btn-brand w-full"
                >
                  {t("errSend")}
                </button>
              </div>
            </div>
          )}
          {step === 2 && (
            <div>
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-small btn-brand w-full"
              >
                {t("close")}
              </button>
            </div>
          )}
        </div>
      </div>
    </CustomModal>
  );
}
